var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-animate",rawName:"v-lazy-animate",value:(0.2),expression:"0.2"}],staticClass:"new-product-wrap"},[_c('LineWrap',{attrs:{"titleObj":_vm.titleObj}}),_c('ProductCarousel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }